import { Box, Checkbox, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";
import { THEME } from "../../theme";
import { projectFileStyles } from "./styles";
import { FileStateReverseMap, ProjectFileProps } from "./types";
import { FileState } from "../../proto/api_pb";
import { UpdateProjectFilesResponse } from "../../proto/api_pb";
import { ProjectFile as ProjectFileClass } from "../../proto/api_pb";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../contexts";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { updateProjectFiles } from "../../services/projectService";
import { toast } from "react-toastify";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import PhotoIcon from "@mui/icons-material/Photo";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteConfirmationModal from "../Modal/DeleteConfirmationModal";
import { useLocation } from "react-router-dom";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export const ProjectFile: React.FC<ProjectFileProps> = ({
  projectFile,
  session,
  setInbox,
  getProjectFiles,
  isFileChecked,
  handleCheckedFileChange,
  setProjectFiles,
  isAddFolderToProject,
  allowDownload,
  setIsPreviewModalOpen,
  setSelectedFileToPreview,
}) => {
  // const [singleProject, setSingleProject] = useState<Project>();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const { enterprise } = useContext(UserDetailsContext);
  // const { id } = useParams();
  const { getValidAccessToken } = useGetValidAccessToken();
  // const isSmallScreen = useMediaQuery("(max-width:600px)");
  const timestamp = projectFile.getTimestamp() ?? 0;
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  const location = useLocation();
  const { projectId, folderIdFromNavigation } = location.state || {};
  const isAddToProjectPage =
    (window.location.pathname.includes("my-tracks") &&
      folderIdFromNavigation) ||
    projectId;
  const isHubPage =
    window.location.pathname.includes("my-tracks") && !isAddToProjectPage;
  const isProjectorFolderOpen = window.location.pathname.includes("project");
  const isSharedContentPage = window.location.pathname.includes("/share/");
  // useEffect(() => {
  //   const fetchProject = async () => {
  //     const token = await getValidAccessToken();
  //     const res = await getProject(token, id!, enterprise?.id as string);
  //     if (res instanceof GetProjectResponse) {
  //       setSingleProject(res.getProject());
  //     }
  //   };
  //   fetchProject();
  // }, [enterprise?.id, getValidAccessToken, id]);

  function convertKbToMB(kb: number): string {
    const kbInGb = 1024 * 1024;
    const gb = kb / kbInGb;
    return gb.toFixed(2);
  }

  async function downloadFile(url: string): Promise<void> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const urlObject = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = urlObject;
      a.download = url.split("/").pop() || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(urlObject);
    } catch (error) {
      console.error("There was an error downloading the file:", error);
    }
  }

  // const createGroupChat = (
  //   id: string | undefined,
  //   title: string | undefined,
  //   contributors: Collaborator[] | undefined
  // ) => {
  //   handleCreateGroupChat(
  //     talkJsContext,
  //     contributors,
  //     navigate,
  //     undefined,
  //     id,
  //     title
  //   );
  // };

  const deleteProjectFile = async () => {
    const p = new ProjectFileClass();
    p.setId(projectFile.getId());
    p.setFileName(projectFile.getFileName());
    p.setFileUrl(projectFile.getFileUrl());
    p.setFileState(
      FileStateReverseMap[
        isHubPage ? FileState.FILE_STATE_DELETED : FileState.FILE_STATE_ACTIVE
      ]
    );
    p.setFileSize(projectFile.getFileSize());
    p.setOwnerId(projectFile.getOwnerId());
    p.setProjectId(isHubPage ? projectFile.getProjectId() : "");
    p.setTimestamp(projectFile.getTimestamp());
    p.setType(projectFile.getType());
    p.setEnterpriseId(enterprise?.id as string);

    const token = await getValidAccessToken();
    const res = await updateProjectFiles(token, [p]);
    if (res instanceof UpdateProjectFilesResponse) {
      toast.info("file deleted");
      await getProjectFiles();
      setProjectFiles((prevFiles) => {
        return prevFiles.filter((file) => file.getId() !== projectFile.getId());
      });
      setIsConfirmationModalOpen(false);
    }
  };

  const shouldShowDownload = !isSharedContentPage || allowDownload;

  return (
    <>
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isMessageModalOpen={isConfirmationModalOpen}
          message="Are you sure you want to delete the file?"
          toggle={() => setIsConfirmationModalOpen((prev) => !prev)}
          handleConfirm={deleteProjectFile}
        />
      )}
      <Box
        onClick={() => {
          if (setSelectedFileToPreview) setSelectedFileToPreview(projectFile);
          if (setIsPreviewModalOpen !== undefined) setIsPreviewModalOpen(true);
        }}
        sx={{
          ...(projectFile.getType().includes("audio")
            ? projectFileStyles.mp3RowStyle
            : projectFile.getType().includes("pdf")
              ? projectFileStyles.pdfRowStyles
              : projectFile.getType().includes("image")
                ? projectFileStyles.imageRowStyle
                : projectFile.getType().includes("video")
                  ? projectFileStyles.videoRowStyle
                  : projectFileStyles.defaultRowStyle),
          ...projectFileStyles.mainContainer,
        }}
      >
        <Box
          sx={{
            ...projectFileStyles.nameContainer,
            width: isSharedContentPage ? "65%" : "400px",
          }}
        >
          {!isSharedContentPage &&
            ((!isAddFolderToProject && isAddToProjectPage) ||
              isHubPage ||
              isProjectorFolderOpen) &&
            isFileChecked && (
              <Checkbox
                onClick={(e) => {
                  e.stopPropagation();
                }}
                checked={isFileChecked(projectFile)}
                size="small"
                {...label}
                onChange={(e) => {
                  e.stopPropagation();
                  if (handleCheckedFileChange && projectFile) {
                    handleCheckedFileChange(projectFile, projectFile.getId());
                  }
                }}
              />
            )}
          {projectFile.getType().includes("video") ? (
            <VideoFileIcon sx={{ fontSize: "40px" }} />
          ) : projectFile.getType().includes("audio") ? (
            <AudioFileIcon sx={{ fontSize: "40px" }} />
          ) : projectFile.getType().includes("image") ? (
            <PhotoIcon sx={{ fontSize: "40px" }} />
          ) : projectFile.getType().includes("pdf") ? (
            <PictureAsPdfIcon sx={{ fontSize: "40px" }} />
          ) : (
            <DescriptionIcon sx={{ fontSize: "40px" }} />
          )}
          <Tooltip placement="top" title={projectFile.getFileName()}>
            <Typography sx={projectFileStyles.nameTypography}>
              {projectFile.getFileName()}
            </Typography>
          </Tooltip>
        </Box>
        {!isSharedContentPage && (
          <>
            <Box sx={{ width: "100px" }}>
              <Tooltip placement="top" title={projectFile.getType()}>
                <Typography sx={projectFileStyles.typeTypography}>
                  {projectFile.getType()}
                </Typography>
              </Tooltip>
            </Box>
            <Box sx={{ width: "100px" }}>
              <Typography sx={projectFileStyles.typeTypography}>
                {`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`}
              </Typography>
            </Box>
            <Box sx={{ width: "100px" }}>
              <Typography sx={projectFileStyles.typeTypography}>
                {`${mm}/${dd}/${year}`}
              </Typography>
            </Box>
            <Box sx={{ width: "100px" }}>
              <Typography sx={projectFileStyles.typeTypography}>
                {convertKbToMB(projectFile.getFileSize()) + "MB"}
              </Typography>
            </Box>
          </>
        )}
        <Box
          sx={{
            ...projectFileStyles.actionsContainer,
            width: isSharedContentPage ? "30%" : "200px",
          }}
        >
          {isSharedContentPage ? (
            allowDownload && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(projectFile.getFileUrl());
                }}
              >
                <DownloadIcon sx={{ fontSize: "20px" }} />
              </IconButton>
            )
          ) : (
            <>
              {shouldShowDownload && (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadFile(projectFile.getFileUrl());
                  }}
                >
                  <DownloadIcon sx={{ fontSize: "20px" }} />
                </IconButton>
              )}
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  toast.warn("coming soon");
                }}
              >
                <img
                  style={{
                    width: "17px",
                    height: "17px",
                    filter:
                      THEME === "light"
                        ? "invert(100%)"
                        : "invert(0%) contrast(50%)",
                  }}
                  src="/assets/icons/TracksPageIcons/share-07.svg"
                  alt="icon"
                />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setIsConfirmationModalOpen(true);
                }}
              >
                <DeleteIcon sx={{ fontSize: "20px" }} />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};
